export default __webpack_public_path__ + "static/media/vire12.1f4cccad.jpg";